<template>
  <div class="mb-12">
    <h1 class="text-center">Cohorts</h1>
    <router-link
      class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-2 hover:bg-green-900 no-underline rounded-full inline-block"
      to="/cohort-add"
    >
      Add Cohort
    </router-link>
    <Table :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import cohortMixin from "@/mixins/cohortMixin"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  mixins: [cohortMixin],
  data() {
    return {
      endpoint: `${siteConfig.siteURL}cohorts/`,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
        },
        { header: { textContent: "Id" }, path: "id" },
        {
          header: {
            textContent: "Slug",
          },
          path: "slug",
        },
        {
          header: { textContent: "Flags" },
          classList: "break-words",
          path: "/",
          formatter: this.getCohortFlags,
        },
        {
          header: { textContent: "Tags" },
          path: "cohort_tag_id",
          formatter: this.getCohortTagsHTML,
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          type: "date",
          path: "created_on",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Calendar" },
          path: "id",
          formatter: id =>
            `<a target="_blank" href="/calendar/${id}">Calendar</a>`,
        },
        {
          header: {
            textContent: "Option",
          },

          path: "id",
          type: "action",
          actionButtonText: "Edit",
          routePath: "/cohort-edit/:readingId",
        },
      ],
      cohortList: [],
    }
  },
  created() {
    this.fetchCohortTags()
  },
  methods: {
    getCohortFlags(cohort) {
      let flags = ""
      if (cohort.data) {
        if (cohort.data.disableUserChat) {
          flags += "ChatDisabled,<br/>"
        }
        if (cohort.data.disableGroupChat) {
          flags += "GroupChatDisabled,<br/>"
        }
        if (cohort.data.disableNotificationEvents) {
          flags += "EventsDisabled,<br/>"
        }
        if (cohort.data.disableNotificationEmails) {
          flags += "EmailsDisabled,<br/>"
        }
      }
      return flags.length > 0 ? flags : "--"
    },
    archiveCohort(cohort) {
      // will be used later
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}cohorts/${cohort.id}/archive/true`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        // fetch the cohorts again
      })
    },
  },
}
</script>
